
const constants = {
    PRIVATE: "private",
    PUBLIC: "public"
}

export default constants
